import React from 'react';
import AILoadingAnimation from '../../../common/AILoadingAnimation';

export const WorkflowDescriptionSkeleton = () => {
  const messages = ['Processing...', 'Analyzing...', 'Generating...', 'Finalizing...'];

  return (
    <AILoadingAnimation
      messages={messages}
      containerSx={{
        background: 'var(--color-bg-paper)',
        border: '1px solid var(--color-divider)',
        borderRadius: '8px',
        minHeight: '180px',
        position: 'relative',
        overflow: 'hidden',
      }}
    />
  );
};
